import { scoreFromFormula, scoreFromLookup } from './score'

describe('scoreFromFormula (순수)', () => {
  it('scoreFormula 없으면 null', async () => {
    expect(await scoreFromFormula(null, 5)).toBeNull()
    expect(await scoreFromFormula('', 5)).toBeNull()
    expect(await scoreFromFormula(undefined, 5)).toBeNull()
  })

  it("변수 'value' 를 측정값으로 치환해 계산한다", async () => {
    expect(await scoreFromFormula('value * 20', 4)).toEqual({ score: 80, calculationMethod: 'formula' })
    expect(await scoreFromFormula('round(value / 2, 1)', 7)).toEqual({ score: 3.5, calculationMethod: 'formula' })
  })

  it('if() 로 분기 계산', async () => {
    expect((await scoreFromFormula('if(value, 100, 0)', 3))!.score).toBe(100)
    expect((await scoreFromFormula('if(value, 100, 0)', 0))!.score).toBe(0)
  })

  it('결과가 NaN 이면 null (예: 0/0)', async () => {
    expect(await scoreFromFormula('value / value', 0)).toBeNull()
  })

  it('구문 오류는 예외로 전파된다 (서비스가 catch)', async () => {
    await expect(scoreFromFormula('value +', 5)).rejects.toThrow()
  })
})

describe('scoreFromLookup (순수, deprecated)', () => {
  const grades = [
    { minValue: 0, maxValue: 10, score: 1 },
    { minValue: 11, maxValue: 20, score: 2 },
    { minValue: 21, maxValue: 100, score: 3 }
  ]

  it('grades 없으면 null', () => {
    expect(scoreFromLookup(undefined, 5)).toBeNull()
    expect(scoreFromLookup([], 5)).toBeNull()
  })

  it('구간에 맞는 score 반환 (경계 포함)', () => {
    expect(scoreFromLookup(grades, 5)).toEqual({ score: 1, calculationMethod: 'lookup' })
    expect(scoreFromLookup(grades, 0)).toEqual({ score: 1, calculationMethod: 'lookup' }) // minValue 포함
    expect(scoreFromLookup(grades, 10)).toEqual({ score: 1, calculationMethod: 'lookup' }) // maxValue 포함
    expect(scoreFromLookup(grades, 15)).toEqual({ score: 2, calculationMethod: 'lookup' })
    expect(scoreFromLookup(grades, 100)).toEqual({ score: 3, calculationMethod: 'lookup' })
  })

  it('어느 구간에도 없으면 null', () => {
    expect(scoreFromLookup(grades, 200)).toBeNull()
    expect(scoreFromLookup(grades, -1)).toBeNull()
  })
})
